import axios from "axios";
import { getCoordinates } from "./coordinates";
import { getDeviceInfo } from "./device-info";

export * from "./coordinates";

export const getFingerprint = async () => {
  const fingerprint = await getDeviceInfo();
  const coordinates = await getCoordinates();
  let data = {};
  try {
    const response = await axios.get("https://extreme-ip-lookup.com/json");
    data = response.data;
  } catch (exp) {}

  return {
    ...fingerprint,
    ...data,
    coordinates,
  };
};
